import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'ur',
  months: ['جنوری', 'فروری', 'مارچ', 'اپریل', 'مئی', 'جون', 'جولائی', 'اگست', 'ستمبر', 'اکتوبر', 'نومبر', 'دسمبر'],
  monthsShort: ['جنوری', 'فروری', 'مارچ', 'اپریل', 'مئی', 'جون', 'جولائی', 'اگست', 'ستمبر', 'اکتوبر', 'نومبر', 'دسمبر'],
  weekdays: ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'],
  weekdaysMin: ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'],
  weekdaysShort: ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: '‏DD/MM/YYYY',
    LL: '‏D MMMM، YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': '‏D MMMM',
    LLL: '‏D MMMM، YYYY HH:mm',
    'LLL-Y': '‏D MMMM HH:mm',
    LLLL: '‏dddd، D MMMM، YYYY HH:mm',
    'LLLL-Y': '‏dddd، D MMMM، HH:mm',
    l: '‏D/M/YYYY',
    'l-Y': '‏D/M',
    ll: '‏D MMM، YYYY',
    'll-Y': '‏D MMM',
    'll-D': 'MMM YYYY',
    lll: '‏D MMM، YYYY h:mm A',
    'lll-Y': '‏D MMM h:mm A',
    llll: '‏ddd، D MMM، YYYY h:mm A',
    'llll-Y': '‏ddd، D MMM h:mm A',
    'll-Y+w': '‏ddd، D MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': '‏D MMMM، YYYY HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'صبح', pm: 'شام', AM: 'صبح', PM: 'شام' },
  past: {
    y: { one: '%s سال پہلے', other: '%s سال پہلے' },
    M: { one: '%s ماہ قبل', other: '%s ماہ قبل' },
    w: { one: '%s ہفتے پہلے', other: '%s ہفتے پہلے' },
    d: { one: '%s دن پہلے', other: '%s دن پہلے' },
    h: { one: '%s گھنٹے پہلے', other: '%s گھنٹے پہلے' },
    m: { one: '%s منٹ پہلے', other: '%s منٹ پہلے' },
    s: { one: '%s سیکنڈ پہلے', other: '%s سیکنڈ پہلے' },
  },
  future: {
    y: { one: '%s سال میں', other: '%s سال میں' },
    M: { one: '%s ماہ میں', other: '%s ماہ میں' },
    w: { one: '%s ہفتے میں', other: '%s ہفتے میں' },
    d: { one: '%s دن میں', other: '%s دنوں میں' },
    h: { one: '%s گھنٹے میں', other: '%s گھنٹے میں' },
    m: { one: '%s منٹ میں', other: '%s منٹ میں' },
    s: { one: '%s سیکنڈ میں', other: '%s سیکنڈ میں' },
  },
  pastLong: {
    y: { one: '%s سال پہلے', other: '%s سال پہلے' },
    M: { one: '%s مہینہ پہلے', other: '%s مہینے پہلے' },
    w: { one: '%s ہفتہ پہلے', other: '%s ہفتے پہلے' },
    d: { one: '%s دن پہلے', other: '%s دنوں پہلے' },
    h: { one: '%s گھنٹہ پہلے', other: '%s گھنٹے پہلے' },
    m: { one: '%s منٹ پہلے', other: '%s منٹ پہلے' },
    s: { one: '%s سیکنڈ پہلے', other: '%s سیکنڈ پہلے' },
  },
  futureLong: {
    y: { one: '%s سال میں', other: '%s سال میں' },
    M: { one: '%s مہینہ میں', other: '%s مہینے میں' },
    w: { one: '%s ہفتہ میں', other: '%s ہفتے میں' },
    d: { one: '%s دن میں', other: '%s دنوں میں' },
    h: { one: '%s گھنٹے میں', other: '%s گھنٹے میں' },
    m: { one: '%s منٹ میں', other: '%s منٹ میں' },
    s: { one: '%s سیکنڈ میں', other: '%s سیکنڈ میں' },
  },
  abbr: {
    y: { one: '%s سال۔', other: '%s سال۔' },
    M: { one: '%s مہینہ', other: '%s مہینے' },
    w: { one: '%s ہفتہ', other: '%s ہفتے' },
    d: { one: '%s دن', other: '%s دن' },
    h: { one: '%s گھنٹہ', other: '%s گھنٹے' },
    m: { one: '%s منٹ', other: '%s منٹس' },
    s: { one: '%s سیکنڈ', other: '%s سیکنڈز' },
  },
  full: {
    y: { one: '%s سال', other: '%s سال' },
    M: { one: '%s مہینہ', other: '%s مہینے' },
    w: { one: '%s ہفتہ', other: '%s ہفتے' },
    d: { one: '%s دن', other: '%s دن' },
    h: { one: '%s گھنٹہ', other: '%s گھنٹے' },
    m: { one: '%s منٹ', other: '%s منٹ' },
    s: { one: '%s سیکنڈ', other: '%s سیکنڈ' },
  },
  justNow: 'بالکل ابھی',
  yesterday: 'گزشتہ کل',
  today: 'آج',
  tomorrow: 'آنے والا کل',
  weekStart: 0,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s %$2s',
  timePref: { 'HH:mm': 'h:mm A' },
  timeRangeStyles: {
    yl: { start: '‏D MMMM، YYYY', end: 'D MMMM، YYYY' },
    'yl-1': { start: '‏D MMMM', end: 'D MMMM، YYYY' },
    ml: { start: '‏D MMMM', end: 'D MMMM' },
    'ml-1': { start: '‏D', end: 'D MMMM YYYY' },
    dl: { start: '‏D', end: 'D MMMM' },
    y: { start: '‏D MMM، YYYY', end: 'D MMM، YYYY' },
    'y-1': { start: '‏D MMM', end: 'D MMM، YYYY' },
    m: { start: '‏D MMM', end: 'D MMM' },
    'm-1': { start: '‏D', end: 'D MMM YYYY' },
    d: { start: '‏D', end: 'D MMM' },
    Y: { start: 'ddd، D MMM، YYYY', end: 'ddd، D MMM، YYYY' },
    'Y-1': { start: 'ddd، D MMM', end: 'ddd، D MMM، YYYY' },
    M: { start: 'ddd، D MMM', end: 'ddd، D MMM' },
    D: { start: 'ddd، D MMM', end: 'ddd، D MMM' },
    yt: { start: '‏D MMM، YYYY HH:mm', end: 'D MMM، YYYY HH:mm' },
    mt: { start: '‏D MMM HH:mm', end: 'D MMM HH:mm' },
    dt: { start: '‏D MMM HH:mm', end: 'D MMM HH:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: '‏D MMM، YYYY HH:mm', end: 'D MMM، YYYY HH:mm ([GMT]Z)' },
    'mt+to': { start: '‏D MMM HH:mm', end: 'D MMM HH:mm ([GMT]Z)' },
    'dt+to': { start: '‏D MMM HH:mm', end: 'D MMM HH:mm ([GMT]Z)' },
    't+to': { start: 'HH:mm', end: 'HH:mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'ur';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'صبح' : 'صبح';
    } else {
      return isLowerCase ? 'شام' : 'شام';
    }
  },
};
